export default __webpack_public_path__ + "static/pawelk-45c1cbe7a3ba75925d7fe511e920ab32.png";